import { render } from "./ValidationView.vue?vue&type=template&id=3597f268&ts=true"
import script from "./ValidationView.vue?vue&type=script&lang=ts"
export * from "./ValidationView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__